module.exports = __webpack_public_path__ + "img/err.63d663ba.png";